import * as React from 'react';
import { MenuItem } from '@chakra-ui/react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

export const AddColumnAfterMenuItem = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().addColumnAfter().run()}
         icon={<FontAwesomeIcon icon={faArrowRight} size="lg" />}
         title={_js('Add column to the right')}
         isDisabled={!editor.can().addColumnAfter()}
         iconSpacing={0}
      />
   );
};
